/* eslint-disable @typescript-eslint/no-explicit-any */
import { isPartyExpected, isPartySeated, isPartyWalkIn } from 'utils/partyUtils';
import PartyListTabs from 'constants/service/partyListTabs';

export const getPartyListTabForParty = (party: any): string => {
  if (isPartyExpected(party)) {
    return PartyListTabs.expected;
  } else if (isPartySeated(party)) {
    return PartyListTabs.seated;
  } else {
    return PartyListTabs.finished;
  }
};

export const getPartyListTabForPartyWalkIn = (party: any): string => {
  if (isPartyExpected(party) && !isPartyWalkIn(party)) {
    return PartyListTabs.expected;
  } else if (isPartyExpected(party) && isPartyWalkIn(party)) {
    return PartyListTabs.walkIn;
  } else if (isPartySeated(party)) {
    return PartyListTabs.seated;
  } else {
    return PartyListTabs.finished;
  }
};
